import { atom } from "recoil";
export const filterTradingList = atom({
  default: {},
  key: "filter-trading",
});
